import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  PageTitle,
  scrollToTop,
  TableEmptyMessage,
} from "../../../../components/Utils";
import { connect } from "react-redux";
import { exportLoginBehaviorReport, loadLoginBehaviorReport } from "../../actions/report";
import { PrimaryButton } from "../../../../components/Buttons";
import TablePageReport from "../../../../components/TablePageReport";
import LoginBehaviorFilter from "../../components/reports/LoginBehaviorFilter";


const mapStateToProps = (state) => {
  return {
    isLoading: state.task.loading,
    reportInterval: state.task.loginBehaviorReportInterval,
    dataItems: state.task.loginBehaviorReport,
  };
};
const mapDispatchToProps = (dispatch) => ({
  loadReport: (...args) => dispatch(loadLoginBehaviorReport(...args)),
  exportReport: (...args) => dispatch(exportLoginBehaviorReport(...args)),
});


const LoginBehaviorTable = ({
  isLoading,
  rows,
  reportInterval,
  dataItems,
  loadReport,
  exportReport,
}) => {
  const [first, setFirst] = React.useState(0);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  const columnStyle = {
    verticalAlign: "top",
    paddingTop: "16px",
    paddingBottom: "16px",
  };
  return (
    <div>
      <PageTitle>
        <div className="w3-right">
          <PrimaryButton
            onClick={() => exportReport(reportInterval)}
            disabled={isLoading || dataItems.length === 0}
          >
            {`Report exportieren`}
          </PrimaryButton>
        </div>
        <h3 className="no-margin pad-btm">{"Reporting: Loginverhalten"}</h3>
      </PageTitle>
      <LoginBehaviorFilter
        reportInterval={reportInterval}
        filterReport={loadReport}
      />
      <DataTable
        value={dataItems}
        paginator={dataItems.length > rows}
        rows={rows}
        first={first}
        onPage={(event) => {
          setFirst(event.first);
          scrollToTop();
        }}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={dataItems.length}
            filteredRecords={dataItems.length}
            first={first}
            rows={rows}
            emptyText="Keine Daten"
            itemName="Datensatz"
            itemNamePlural="Datensätze"
          />
        }
        removableSort
        sortMode="multiple"
        emptyMessage={
          isLoading ? null : (
            <TableEmptyMessage itemNamePlural="Datensätze" />
          )
        }
      >
        <Column
          field="reportDate"
          header="Tag"
          sortable={dataItems.length > 1}
          filter={dataItems.length > rows}
          filterMatchMode="contains"
          style={{ ...columnStyle, width: "14em" }}
        />
        <Column
          field="vodafoneLogins"
          header="Gesamtanzanl Anmeldungen Vodafone"
          sortable={dataItems.length > 1}
          filter={dataItems.length > rows}
          filterMatchMode="contains"
          style={{ ...columnStyle, textAlign: "center" }}
        />
        <Column
          field="partnerLogins"
          header="Gesamtanzanl Anmeldungen Vertragspartner"
          sortable={dataItems.length > 1}
          filter={dataItems.length > rows}
          filterMatchMode="contains"
          style={{ ...columnStyle, textAlign: "center" }}
        />
        <Column
          field="maxConcurrentLogins"
          header="Max gleichzeitige Zugriffe pro Tag"
          sortable={dataItems.length > 1}
          filter={dataItems.length > rows}
          filterMatchMode="contains"
          style={{ ...columnStyle, textAlign: "center" }}
        />
      </DataTable>
    </div>
  );
};

LoginBehaviorTable.propTypes = {
  isLoading: PropTypes.bool,
  reportInterval: PropTypes.array,
  dataItems: PropTypes.arrayOf(PropTypes.shape({
    reportDate: PropTypes.string,
    vodafoneLogins: PropTypes.number,
    partnerLogins: PropTypes.number,
    maxConcurrentLogins: PropTypes.number,
  })),
  loadReport: PropTypes.func.isRequired,
  exportReport: PropTypes.func.isRequired,
  rows: PropTypes.number,
};

LoginBehaviorTable.defaultProps = {
  isLoading: false,
  dataItems: [],
  rows: 10,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginBehaviorTable);
